module.exports = __webpack_public_path__ + "011590a56e94fe96862482bf5446673b.svg";